import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-rose-900 via-red-800 to-amber-900"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=abstract%20dark%20geometric%20pattern%20with%20warm%20red%20and%20gold%20accents%2C%20subtle%20grain%20texture%2C%20modern%20minimal%20background%2C%20luxury%20vibe&width=1800&height=1200&seq=hero-bg-pattern&orientation=landscape')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 text-background-50 text-xs md:text-sm font-medium mb-6 backdrop-blur-sm whitespace-nowrap">
              {heroData.tagline}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4 font-heading">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-background-50/85 mb-6 max-w-xl lg:max-w-none">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-8 max-w-2xl lg:max-w-none">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8 justify-center lg:justify-start">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=dramatic%20abstract%20composition%20with%20warm%20red%20and%20gold%20gradients%2C%20luxury%20velvet%20texture%2C%20mysterious%20spotlight%20effect%2C%20theatrical%20drama%20atmosphere%2C%20cinematic%20lighting%2C%20elegant%20dark%20mood%2C%20gossip%20and%20entertainment%20theme%20visual&width=1200&height=1500&seq=hero-main-visual&orientation=portrait"
                alt="51吃瓜网站 - 全网最新吃瓜资源聚合平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="bg-white/10 backdrop-blur-md rounded-xl px-4 py-3 border border-white/10">
                  <div className="flex items-center gap-2 text-background-50 text-xs">
                    <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                    <span className="font-medium">实时更新中</span>
                    <span className="text-background-50/50 ml-auto">今日已更新 186 条</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}